import { Directive, ViewContainerRef } from "@angular/core";

@Directive({
    selector: '[table-context-menu-container]'
})
export class TableContextMenuContainerDirective {
    constructor(public viewContainerRef: ViewContainerRef){
    }
}